// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.flex-row[data-v-14eebec2] {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  flex-basis: 48%;\n}\n.flex-row .ui-toggle[data-v-14eebec2] {\n  display: inline-block;\n}\n.tools-buttons[data-v-14eebec2] {\n  display: flex;\n  flex-wrap: wrap;\n  height: 3.4rem;\n  justify-content: flex-end;\n  margin-top: 1.15rem;\n}\n@media (max-width: 800px) {\n.flex-row[data-v-14eebec2] {\n    flex-basis: 100%;\n}\n}\n", ""]);
// Exports
module.exports = exports;
